import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Utils from "../utils/Utils";

const { serverURL } = Utils;

const initialState = {
    plans: [],
    loader:true,
    status:"success"
};


export const plan = createAsyncThunk(
  "plan/all",
  async () => {
    console.log("plans::Fetching all plans from server...");
    const response = await fetch(`${serverURL}/plan/active/`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    });
    if (!response.ok) throw new Error(await response.text());
    const data = await response.json();
    return data ;
  }
);


export const publicActivePlans = createAsyncThunk(
  "plan/publicActive",
  async () => {
    console.log("plans::Fetching public active plans from server...");
    const response = await fetch(`${serverURL}/plan-public/active`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
    if (!response.ok) throw new Error(await response.text());
    const data = await response.json();
    return data;
  }
);


export const planSlice = createSlice({
  name: "conversations",
  initialState,
  reducers: {
    setPlans: (state, action) => {
      state.plans = action.payload.plans;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(plan.fulfilled, (state, action) => {
      state.plans = action.payload.data;
      state.status = "success";
    });
    builder.addCase(publicActivePlans.fulfilled, (state, action) => {
      state.plans = action.payload.data;
      state.status = "success";
    });
    builder.addCase(plan.rejected, (state, action) => {
      state.status = "failed";
    });
    builder.addCase(publicActivePlans.rejected, (state, action) => {
      state.status = "failed";
    });
  },
});

export default planSlice.reducer;
export const { setPlans } = planSlice.actions;

